import { Container, IconWrapper, Label } from './styles';

type Props = {
	children?: React.ReactNode;
	title: React.ReactNode;
	icon?: React.ReactNode;
	fullWidth?: boolean;
	selected?: boolean;
	onClick?: React.MouseEventHandler<HTMLLabelElement>;
};

export const GeneratorLabel = ({
	children,
	title,
	icon,
	fullWidth,
	selected,
	onClick,
}: Props) => (
	<Container fullWidth={fullWidth} selected={selected}>
		{icon && <IconWrapper>{icon}</IconWrapper>}
		<Label
			htmlFor={typeof title === 'string' ? title : undefined}
			onClick={onClick}
		>
			{title}
		</Label>
		{children}
	</Container>
);
